import { useEffect, useState } from 'react';

/**
 * Returns whole seconds remaining until `endsAt` (ISO string), ticking every
 * 250ms. Returns 0 when elapsed or when endsAt is undefined.
 */
export function useCountdown(endsAt?: string): number {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (!endsAt) {
      setRemaining(0);
      return;
    }
    const end = new Date(endsAt).getTime();
    const tick = () => {
      const secs = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      setRemaining(secs);
    };
    tick();
    const iv = setInterval(tick, 250);
    return () => clearInterval(iv);
  }, [endsAt]);

  return remaining;
}
